// SCREENS-VIEWER: one session alone in its own window (`/screens/<lease>?c=<slug>`, the
// workspace's "Open in new window"): the same toolbar and live screen as the Screens pane, edge to
// edge, with no app chrome. The company comes from `c` (a lease id alone does not name it).
import { createRoute } from "@tanstack/react-router";
import { SessionWindow } from "../features/agent-screens/session-pane";
import { companyBySlug } from "../features/company";
import { SessionContext, useSession } from "../features/use-feature";
import { NotFoundPage } from "../pages/status-pages";
import { authedRoute } from "./_authed";

const SLUG = /^[a-z0-9][a-z0-9-]{0,62}$/;

export const screenWindowRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: "screens/$lease",
  validateSearch: (s: Record<string, unknown>): { c?: string } =>
    typeof s.c === "string" && SLUG.test(s.c) ? { c: s.c } : {},
  component: function ScreenWindow() {
    const { api } = screenWindowRoute.useRouteContext();
    const { lease } = screenWindowRoute.useParams();
    const { c } = screenWindowRoute.useSearch();
    const { me } = useSession();
    const company = c ? companyBySlug(me, c) : null;
    if (!company) return <NotFoundPage message="This screen does not exist." />;
    return (
      <SessionContext.Provider value={{ me, company }}>
        <SessionWindow api={api} co={company.id} slug={company.slug} leaseId={lease} />
      </SessionContext.Provider>
    );
  },
});
